var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"googleMap",staticClass:"google-map"},[(Boolean(this.googleApi) && Boolean(this.map))?[_vm._t("default",null,{"googleApi":_vm.googleApi,"map":_vm.map})]:_vm._e()],2)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }